<template>
  <transition name="om-fade">
    <div v-if="manual" class="om-scope om-backdrop">
      <div class="om-dialog" role="alertdialog" aria-modal="true" aria-labelledby="om-notice-title">
        <div class="om-dialog-head">
          <span class="om-dialog-icon" aria-hidden="true"><i class="ni ni-book-bookmark"></i></span>
          <div>
            <p class="om-dialog-badge">{{ copy.noticeBadge }} · {{ version.label }}</p>
            <h3 id="om-notice-title" class="om-dialog-title">{{ copy.noticeTitle }}</h3>
          </div>
        </div>
        <p class="om-dialog-lead">{{ copy.noticeLead }}</p>
        <div class="om-dialog-changes">
          <p class="om-eyebrow">{{ copy.whatChanged }} · {{ copy.publishedOn }} {{ publishedOn }}</p>
          <ul>
            <li v-for="line in changeLines" :key="line">{{ line }}</li>
          </ul>
        </div>
        <p v-if="hasError" class="om-dialog-error">{{ copy.loadError }}</p>
        <div class="om-dialog-actions">
          <button type="button" class="om-button om-button-ghost" @click="viewChanges">{{ copy.viewChanges }}</button>
          <button type="button" class="om-button" :disabled="isSaving" @click="acknowledge">
            {{ isSaving ? copy.acknowledging : copy.acknowledge }}
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import './operations-manual.css';
import { MANUAL_COPY, MANUAL_ROUTES, changeNoteLines, formatManualDate } from './manualCopy';

export default {
  name: 'ManualAcknowledgementNotice',
  data() {
    return { copy: MANUAL_COPY, isDismissedForNow: false, isSaving: false, hasError: false };
  },
  computed: {
    manual() {
      if (this.isDismissedForNow) return null;
      return this.$store.getters['operationsManual/pendingManuals'][0] || null;
    },
    version() {
      return this.manual.current_version;
    },
    changeLines() {
      return changeNoteLines(this.version.change_notes);
    },
    publishedOn() {
      return formatManualDate(this.version.published_at);
    },
  },
  watch: {
    manual(current) {
      document.body.classList.toggle('om-notice-open', Boolean(current));
    },
  },
  mounted() {
    this.$store.dispatch('operationsManual/fetchManuals');
  },
  beforeDestroy() {
    document.body.classList.remove('om-notice-open');
  },
  methods: {
    viewChanges() {
      const manualKey = this.manual.key;
      this.isDismissedForNow = true;
      const target = { name: MANUAL_ROUTES.home, params: { manualKey } };
      if (this.$route.name !== MANUAL_ROUTES.home || this.$route.params.manualKey !== manualKey) this.$router.push(target);
    },
    async acknowledge() {
      this.isSaving = true;
      this.hasError = false;
      try {
        await this.$store.dispatch('operationsManual/acknowledge', { manualKey: this.manual.key, versionId: this.version.id });
      } catch (error) {
        this.hasError = true;
      } finally {
        this.isSaving = false;
      }
    },
  },
};
</script>

<style scoped>
.om-backdrop { position: fixed; inset: 0; z-index: 1070; background: rgba(18, 28, 23, .6); display: flex; align-items: center; justify-content: center; padding: 16px; }
.om-dialog { background: var(--om-surface); width: 100%; max-width: 540px; max-height: 92vh; overflow-y: auto; border-radius: 18px; padding: 24px; box-shadow: 0 20px 50px rgba(0, 0, 0, .25); }
.om-dialog-head { display: flex; gap: 14px; align-items: flex-start; margin-bottom: 10px; }
.om-dialog-icon { width: 44px; height: 44px; flex-shrink: 0; border-radius: 12px; background: var(--om-green-tint); color: var(--om-green-dark); display: flex; align-items: center; justify-content: center; font-size: 20px; }
.om-dialog-badge { margin: 0; font-size: 12px; font-weight: 700; color: var(--om-green-dark); }
.om-dialog-title { margin: 2px 0 0; font-size: 20px; font-weight: 750; line-height: 1.25; color: var(--om-ink); }
.om-dialog-lead { color: var(--om-muted); font-size: 14px; line-height: 1.5; margin: 0 0 16px; }
.om-dialog-changes { background: var(--om-soft); border: 1px solid var(--om-line); border-radius: 12px; padding: 14px 16px; margin-bottom: 18px; }
.om-dialog-changes ul { margin: 0; padding-left: 20px; }
.om-dialog-changes li { margin-bottom: 6px; line-height: 1.5; }
.om-dialog-error { color: #d63a5a; font-size: 13px; margin: 0 0 12px; }
.om-dialog-actions { display: flex; gap: 10px; justify-content: flex-end; flex-wrap: wrap; }
.om-fade-enter-active, .om-fade-leave-active { transition: opacity .2s; }
.om-fade-enter, .om-fade-leave-to { opacity: 0; }
@media (max-width: 576px) {
  .om-backdrop { align-items: flex-end; padding: 0; }
  .om-dialog { max-height: 94vh; border-radius: 18px 18px 0 0; padding: 20px 18px calc(18px + env(safe-area-inset-bottom)); }
  .om-dialog-actions { flex-direction: column-reverse; }
  .om-dialog-actions .om-button { width: 100%; }
}
</style>
